import resume from "./docs/TonnyMakondesa.pdf"
import About from "./about";

const Home = ({Logos}) => {

    const developer = "<Frontend Developer/>";

    return ( 
            <section className='overflow-x-hidden'>    
                <div className="flex justify-center items-center box-border w-full h-screen font-fonts pt-16 bg-background-2 bg-cover bg-center">
                    <div className="px-4 text-center">
                        <h1 className="md:text-6xl text-3xl text-gray-800 font-bold mb-8">hi, i'm Tonny 
                            <br/><span className="text-gray-700 md:3xl text-2xl font-bold">i build things for the web</span>
                        </h1>
                        <ul className="inline">
                            {Logos.map((value)=>(
                                <li className="inline text-xl mr-2">
                                <a target="_blank" className="hover:opacity-50 text-gray-700" href={value.link}>{value.logo}</a>
                            </li>
                            ))}
                        </ul>
                    </div>
                </div>
                <About/>
            </section> 
     );
}
 
export default Home;